import HTTP from '@/plugins/http';

const withdrawApi = {
  total: '/withdraw/count',
  page: '/withdraw/list/page',
  review: '/withdraw/review',
  export: '/withdrawOrder/export',
  qrCode: '/withdraw/list/genWithdrawBankOrderQrcode'
};

export function getPage({ data, params }) {
  return HTTP({
    url: withdrawApi.page,
    method: 'post',
    data: { query: data, ...params }
  });
}
export function getTotal(data) {
  return HTTP({
    url: withdrawApi.total,
    method: 'post',
    data
  });
}
export function doReview(data) {
  return HTTP({
    url: withdrawApi.review,
    method: 'post',
    data
  });
}
export function doWithdraw(data) {
  return HTTP({
    url: withdrawApi.withdraw,
    method: 'post',
    data
  });
}

function doExport(data) {
  return HTTP.loading({
    url: withdrawApi.export,
    method: 'post',
    responseType: 'blob',
    data,
    timeout: 600000
  });
}

function getQrCode({ param }) {
  return HTTP({
    url: `${withdrawApi.qrCode}${param}`,
    method: 'get'
  });
}
export default {
  getPage,
  getTotal,
  doReview,
  doWithdraw,
  doExport,
  getQrCode
};



// WEBPACK FOOTER //
// ./src/api/withdrawlist.js